import { Theme } from './types'

const lightTheme: Theme = {
  base: '#EEF1F4',
  surface: '#FFF',
  text: '#172534'
}

export default lightTheme
